/**
 * Canonical Feature Flag Names — mirrors backend FeatureFlagName enum
 * Keep in sync with backend/src/feature-flags/constants/feature-flag.constants.ts
 */
export const FeatureFlagName = {
    BILLING_ENABLED: 'billing_enabled',
    PAYMENTS_ENABLED: 'payments_enabled',
    PRODUCT_ORDERING_ENABLED: 'product_ordering_enabled',
    KYC_SEGREGATION_OF_DUTIES: 'kyc_segregation_of_duties',
    KYC_SABTE_AHVAL_ENABLED: 'kyc_sabte_ahval_enabled',
    KYC_SHAHKAR_ENABLED: 'kyc_shahkar_enabled',
    RESILIENCE_DASTINE_POLL_ENABLED: 'resilience_dastine_poll_enabled',
    MAINTENANCE_MODE_ENABLED: 'maintenance_mode_enabled',
    CERTIFICATE_ISSUE_ENABLED: 'certificate_issue_enabled',
    CERTIFICATE_REVOKE_ENABLED: 'certificate_revoke_enabled',
    PDF_SIGNING_ENABLED: 'pdf_signing_enabled',
    PAYMENT_LINK_ENABLED: 'payment_link_enabled',
    TICKETING_ENABLED: 'ticketing_enabled',
    EVIDENCE_ENABLED: 'evidence_enabled',
};

/**
 * Public flags — safe for unauthenticated clients.
 * Must match backend PublicFeatureFlagController.PUBLIC_FLAG_ALLOWLIST
 */
export const PUBLIC_FLAG_NAMES = [
    FeatureFlagName.PAYMENTS_ENABLED,
    FeatureFlagName.PRODUCT_ORDERING_ENABLED,
    FeatureFlagName.MAINTENANCE_MODE_ENABLED,
    FeatureFlagName.CERTIFICATE_ISSUE_ENABLED,
    FeatureFlagName.CERTIFICATE_REVOKE_ENABLED,
    FeatureFlagName.PDF_SIGNING_ENABLED,
    FeatureFlagName.PAYMENT_LINK_ENABLED,
    FeatureFlagName.TICKETING_ENABLED,
    FeatureFlagName.EVIDENCE_ENABLED,
];

/**
 * Defaults — must match backend FLAG_DEFINITIONS defaultEnabled.
 * Used as safe fallback when public flag fetch fails (do not block entire app).
 */
export const FLAG_DEFAULTS = {
    [FeatureFlagName.BILLING_ENABLED]: false,
    [FeatureFlagName.PAYMENTS_ENABLED]: false,
    [FeatureFlagName.PRODUCT_ORDERING_ENABLED]: true,
    [FeatureFlagName.KYC_SEGREGATION_OF_DUTIES]: false,
    [FeatureFlagName.KYC_SABTE_AHVAL_ENABLED]: true,
    [FeatureFlagName.KYC_SHAHKAR_ENABLED]: true,
    [FeatureFlagName.RESILIENCE_DASTINE_POLL_ENABLED]: true,
    [FeatureFlagName.MAINTENANCE_MODE_ENABLED]: false,
    [FeatureFlagName.CERTIFICATE_ISSUE_ENABLED]: true,
    [FeatureFlagName.CERTIFICATE_REVOKE_ENABLED]: true,
    [FeatureFlagName.PDF_SIGNING_ENABLED]: true,
    [FeatureFlagName.PAYMENT_LINK_ENABLED]: true,
    [FeatureFlagName.TICKETING_ENABLED]: true,
    [FeatureFlagName.EVIDENCE_ENABLED]: true,
};

export default FeatureFlagName;
